(function () {
  function initContainer(container) {
    var track = container.querySelector('.cr-track');
    var dotsContainer = container.querySelector('.cr-dots');
    if (!track || !dotsContainer) return;
    var items = track.querySelectorAll('.cr-item');
    var sliderWindow = container.querySelector('.cr-slider-window');

    var currentIndex = 0;
    var totalItems = items.length;

    function getItemsPerPage() {
      if (window.innerWidth >= 1024) return 3;
      if (window.innerWidth <= 768) return 1;
      return 1;
    }

    function getMaxIndex() {
      var itemsPerPage = getItemsPerPage();
      return Math.ceil(totalItems / itemsPerPage) - 1;
    }

    function getCurrentDotIndex() {
      var itemsPerPage = getItemsPerPage();
      return Math.floor(currentIndex / itemsPerPage);
    }

    function updateCarousel() {
      if (items.length === 0) return;

      var itemsPerPage = getItemsPerPage();
      var itemWidth = items[0].offsetWidth;
      var moveX = currentIndex * itemWidth;
      var maxMoveX = track.scrollWidth - track.parentElement.offsetWidth;

      if (moveX > maxMoveX && maxMoveX > 0) {
        moveX = maxMoveX;
        if (itemWidth > 0) {
          currentIndex = Math.round(maxMoveX / itemWidth);
        }
      }

      var maxItemIndex = totalItems - itemsPerPage;
      if (currentIndex > maxItemIndex && maxItemIndex >= 0) {
        currentIndex = maxItemIndex;
        moveX = currentIndex * itemWidth;
      }

      if (itemsPerPage === 1 && currentIndex === totalItems - 1) {
        moveX = (totalItems - 1) * itemWidth;
      }

      track.style.transform = 'translateX(-' + moveX + 'px)';
      updateDots();
    }

    function updateDots() {
      var maxPageIndex = getMaxIndex();
      var currentDotIndex = getCurrentDotIndex();
      var itemsPerPage = getItemsPerPage();
      dotsContainer.innerHTML = '';

      if (maxPageIndex < 1) return;

      for (var i = 0; i <= maxPageIndex; i++) {
        var dot = document.createElement('button');
        dot.classList.add('cr-dot');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        if (i === currentDotIndex) dot.classList.add('active');

        (function (pageIdx) {
          dot.addEventListener('click', function () {
            currentIndex = pageIdx * itemsPerPage;
            updateCarousel();
          });
        })(i);

        dotsContainer.appendChild(dot);
      }
    }

    updateCarousel();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var oldItemsPerPage = getItemsPerPage();
        updateCarousel();
        var newItemsPerPage = getItemsPerPage();
        if (oldItemsPerPage !== newItemsPerPage) {
          currentIndex = 0;
          updateCarousel();
        }
      }, 100);
    });

    if (!sliderWindow) return;

    var startX = 0;
    var currentX = 0;
    var isDragging = false;
    var trackStartTransform = 0;

    function getCurrentTranslateX() {
      var style = window.getComputedStyle(track);
      var matrix = new DOMMatrixReadOnly(style.transform);
      return matrix.m41;
    }

    sliderWindow.addEventListener('touchstart', function (e) {
      isDragging = true;
      startX = e.touches[0].clientX;
      trackStartTransform = getCurrentTranslateX();
      track.style.transition = 'none';
    }, { passive: true });

    sliderWindow.addEventListener('touchmove', function (e) {
      if (!isDragging) return;
      currentX = e.touches[0].clientX;
      var delta = currentX - startX;
      track.style.transform = 'translateX(' + (trackStartTransform + delta) + 'px)';
    }, { passive: true });

    sliderWindow.addEventListener('touchend', function () {
      if (!isDragging) return;
      isDragging = false;

      var delta = currentX - startX;
      var threshold = 50;

      track.style.transition = 'transform 0.5s ease-in-out';

      if (Math.abs(delta) > threshold) {
        var itemsPerPage = getItemsPerPage();
        if (delta < 0) {
          currentIndex = Math.min(currentIndex + itemsPerPage, totalItems - itemsPerPage);
        } else {
          currentIndex = Math.max(currentIndex - itemsPerPage, 0);
        }
      }

      updateCarousel();
    });
  }

  function init() {
    document.querySelectorAll('.cr-container').forEach(initContainer);
    if (typeof window !== 'undefined') {
      window._klOnsite = window._klOnsite || [];
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
